import { Pipe, PipeTransform } from '@angular/core';
import { PermissionService } from '../services/permissions.service';
import { Observable } from 'rxjs';
import { PERMISSION_TYPE } from '../enums/common.enum';

@Pipe({
  name: 'hasPermission'
})
export class HasPermissionPipe implements PipeTransform {
  constructor(private readonly permissionService: PermissionService) {}

  transform(
    path: string,
    action: PERMISSION_TYPE.READ | PERMISSION_TYPE.WRITE = PERMISSION_TYPE.READ,
    checkDelegate = false,
    checkDelegatedUser = false
  ): Observable<boolean> {
    return this.permissionService.hasPermission(
      path,
      action,
      checkDelegate,
      checkDelegatedUser
    );
  }
}
